// extracted by mini-css-extract-plugin
module.exports = {"container":"WelcomePage_container__Djgx4"};